import React, { createContext, useEffect, useState, useContext } from 'react';
import { LoaderContext } from 'context/LoaderContextProvider';
import { defaultLang, defaultSearchYear, filterLink } from 'utils/constants';
import { useNetwork } from 'services/network';

const FilterContext = createContext();

const FilterContextProvider = ({ locale, isBiennali = false, children }) => {
  const network = useNetwork();
  const [filter, setFilter] = useState();
  const [allFilters, setAllFilters] = useState([]);
  const [yearSelected, setYearSelected] = useState(
    isBiennali ? `${+defaultSearchYear - 1}` : defaultSearchYear
  );

  const { setLoaderActive } = useContext(LoaderContext);
  const showLoader = () => setLoaderActive(true);

  useEffect(() => {
    if (allFilters.length === 0) fetchFilters();
    else renderFilterPerYear();
  }, [allFilters, yearSelected]);

  const fetchFilters = async () => {
    showLoader();
    const res = await network.get(filterLink);
    const _allFilters = res.data;
    Object.entries(_allFilters)
      .sort((a, b) => a - b)
      .map(([key, val]) => {
        setAllFilters((prev) => [
          ...prev,
          {
            alphabet: val.alphabet,
            year: key,
            catalogUpdate: val?.catalog_update_date,
            yearLabels: Object.keys(_allFilters).map((k) => ({
              year: k,
              description: _allFilters[k][`description`] || '',
              description_en: _allFilters[k][`description_en`] || '',
              description_it: _allFilters[k][`description_it`] || '',
            })),
            years: Object.keys(_allFilters).map((k) => k),
            exhibitions: val.events[0].year_events.map((exhibitor) => ({
              ...exhibitor,
              label: getLocalizedDescription(exhibitor),
            })),
            visits:
              val.appuntamenti?.values?.map((v) => ({
                ...v,
                label: getLocalizedDescription(v),
                parentLabel: getLocalizedDescription(val.appuntamenti),
              })) || [],
            halls: val.hall,
            nations: val.nations.map((n) => ({
              ...n,
              label: getLocalizedName(n),
            })),
            ...(val.percorsi_tematici && {
              percorsi_tematici: val.percorsi_tematici.map((n) => ({
                ...n,
                label: getLocalizedParameter(n, 'description'),
              })),
            }),
          },
        ]);
      });
  };

  const renderFilterPerYear = () => {
    const _filter = allFilters.find((f) => f.year === yearSelected);
    showLoader();
    if (_filter) setFilter(_filter);
  };

  const getLocalizedDescription = (obj) => {
    return getLocalizedParameter(obj, 'description');
  };
  const getLocalizedParameter = (obj, param) => {
    const lang = window.location.pathname.split('/')[1];
    return (
      obj?.[`${param}_${lang}`] ??
      obj?.[`${param}_${locale}`] ??
      obj?.[`${param}_${defaultLang}`] ??
      `undefined-${param}`
    );
  };
  const getLocalizedName = (obj) => {
    return getLocalizedParameter(obj, 'name');
  };

  return (
    <FilterContext.Provider value={{ filter, yearSelected, setYearSelected }}>
      {children}
    </FilterContext.Provider>
  );
};

export { FilterContextProvider, FilterContext };
